<div class="error-message-style" *ngIf="errorMessage !== null">{{errorMessage}}</div>